export const FETCH_CURRENT_USER = 'app/App/FETCH_CURRENT_USER';
export const FETCH_CURRENT_USER_ERROR = 'app/App/FETCH_CURRENT_USER_ERROR';
export const FETCH_CURRENT_USER_SUCCESS = 'app/App/FETCH_CURRENT_USER_SUCCESS';

export const CLEAR_CURRENT_USER = 'app/App/CLEAR_CURRENT_USER';

export const SET_CURRENT_COMPANY_ID = 'app/App/SET_CURRENT_COMPANY_ID';

export const LAST_COMPANY_KEY = 'last-company-selected';
